import React from 'react';
import { Version } from '../../../../models/version';
import { useField } from 'formik';
import { Editor } from '../../editor/Editor';
import md5 from 'md5';

import styles from './styles.css';
import { LanguageSelector } from './LanguageSelector';

export interface TextEditorWithLanguageSelectorProps {
  name?: string;
  version: Version;
  readOnly: boolean;
  submitting: boolean;
  onLanguageChanged: (isTouched: boolean) => (language: string) => void;
  setInitialData: (data: string) => void;
  dirtyForm: boolean;
  locale: string;
  initialValue: string;
}

export const TextEditorWithLanguageSelector = ({
  name = 'rawText',
  version,
  readOnly,
  onLanguageChanged,
  setInitialData,
  dirtyForm,
  locale,
  initialValue,
  submitting,
}: TextEditorWithLanguageSelectorProps): React.ReactElement => {
  const [, meta, helpers] = useField({ name });
  const { value } = meta;
  const { setValue } = helpers;

  return (
    <>
      <div className={meta.touched && meta.error ? styles.redBorder : ''}>
        <Editor
          key={`${version.id}-${locale}-${md5(initialValue)}`}
          setData={setValue}
          setInitialData={setInitialData}
          value={value}
          readOnly={readOnly || submitting}
        />
      </div>
      {meta.touched && meta.error ? (
        <span className={meta.error ? styles.error : ''}>{meta.error}</span>
      ) : null}

      <LanguageSelector
        submitting={submitting}
        currentLocale={locale}
        handleSelectedLanguage={onLanguageChanged(dirtyForm)}
      />
    </>
  );
};
